import { mallEntranceApi, mallApi } from '../request'
import { apiPath } from '../api'

export const account = {
  pickupCode: data => mallEntranceApi.post(apiPath.pickupCode, data),
  getCompany: data => mallApi.post(apiPath.getCompany, data),
  companyProtocolQuery: data =>
    mallEntranceApi.post(apiPath.companyProtocolQuery, data),
  signProtocol: data => mallEntranceApi.post(apiPath.signProtocol, data),
  userConfig: data => mallEntranceApi.post(apiPath.userConfig, data),
  submitConfig: data => mallEntranceApi.post(apiPath.submitConfig, data),
  configOperate: data => mallEntranceApi.post(apiPath.configOperate, data),
  configGetByKey: data => mallEntranceApi.post(apiPath.configGetByKey, data)
}
